import cn from 'classnames'
import { FC } from 'react'

import { Partner } from './components/partner'

import { tweets } from './tweets'

import changeNowLogo from './icons/cn-logo.png'
import guardaLogo from './icons/guarda-logo.svg'
import nowWalletLogo from './icons/nw-logo.svg'
import nowNodesLogo from './icons/nowNodes-logo.svg'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

const partners = [
  {
    oneLineLessMargin: true,
    logo: changeNowLogo,
    logoHeight: 99,
    link: 'https://changenow.io/',
    linkAlt: 'changenow.io',
    tweet: tweets[0],
    description: 'best_non_custodial_exchange',
  },
  {
    logo: guardaLogo,
    logoHeight: 99,
    link: 'https://guarda.com/',
    linkAlt: 'guarda.com',
    tweet: tweets[1],
    description: 'best_wallet_safety',
  },
  {
    logo: nowWalletLogo,
    logoHeight: 99,
    link: 'https://walletnow.app/',
    linkAlt: 'walletnow.app',
    description: 'now_wallet_info',
  },
  {
    logo: nowNodesLogo,
    logoHeight: 99,
    link: "https://nownodes.io/nodes",
    linkAlt: "nownodes.io/nodes",
    tweet: tweets [2],
    description: 'web3_full_nodes',
    followLink: true
  },
]

export const OurPartners: FC = () => {
  const { t } = useTranslation()

  return (
    <div className={cn('container', styles.container)}>
      <h2 className={styles.title}>{t('our_partners')}</h2>
      <div className={styles.partners}>
        {
          partners.map(partner => (
            <div className={styles.partnersItem}>
              <Partner
                oneLineLessMargin={partner.oneLineLessMargin}
                logo={partner.logo}
                logoHeight={partner.logoHeight}
                link={partner.link}
                linkAlt={partner.linkAlt}
                tweet={partner.tweet}
                description={<>{t(partner.description)}</>}
                followLink={partner.followLink}
               />
             </div>
          ))
        }
      </div>
    </div>
  )
}
